@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.priceSwingRefinementContainer {
  @include cxy.stack(var(--cxy-spacing-xxsm));
}

.radioGroup {
  display: flex;
  flex-direction: column;
  margin-top: var(--cxy-spacing-xxsm);
}

.resetButton {
  align-self: center;
}

@media screen and (min-width: 801px) {
  .radioGroup {
    flex-direction: row;
  }
  .radioGroup label {
    gap: var(--cxy-spacing-xxxsm);
  }
}
